import { UninitializedPropertyAccessException8qin22n38p0w as UninitializedPropertyAccessException } from '../exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function throwUninitializedPropertyAccessException(name) {
  throw UninitializedPropertyAccessException().new_kotlin_UninitializedPropertyAccessException_egi92l_k$('lateinit property ' + name + ' has not been initialized');
}
//region block: exports
export {
  throwUninitializedPropertyAccessException as throwUninitializedPropertyAccessException14fok093f3k3t,
};
//endregion

//# sourceMappingURL=ThrowHelpers.mjs.map
